 <template>
	<div class="window">
        <div class="header"><span v-html="translation.start_gry"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help1">

                </div>
            </div>
            <button class="btn btn-all btn-green" v-html="translation.kontynuuj_gre" @click="goToPlansza"></button>

            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help2">

                </div>
            </div>    
            <button class="btn btn-all btn-green" v-html="translation.zacznij_od_nowa" @click="goToNewGame"></button>

        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'KontynuujGre',
    props: {
        language: String
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon,
        
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        goToPlansza() {
            this.$emit('go-to-plansza-poziomow');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        goToNewGame() {
            this.$emit('go-nowa-gra');
        }
    },
       watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
a.back-screen span {
    padding-left: 20px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

.podpowiedz {
    background-color: #e0e0e0;
    padding: 15px;
    border: 1px solid #999;
    border-radius: 15px;
    margin-bottom: 2em;
    font-size: 1.2em;
    text-align: center;
        margin-left: 30px;
    margin-right: 30px;
}
.dark .podpowiedz {
    background-color: #333;
    /* padding: 15px; */
    border: 1px solid #999;
    /* border-radius: 15px; */
    /* margin-bottom: 2em; */
    /* font-size: 1.2em; */
    /* text-align: center; */
    color: white;
}
.mt2x {
    margin: 4em 0 0.5em;
}

</style>
